<template lang="">
  <header class="main-header">
    <div class="container-fluid d-none d-lg-block">
      <LazyNavigationBannerBar />
      <nav-bar />
      <search-bar />
      <button-notifications
        v-if="isClientReady && isUserAuthenticated"
        variant="bar"
      />
      <!-- <wishlist-nav style="margin-top: -1.2rem !important" /> -->
      <secondary-nav-bar />
    </div>

    <nav-bar-mobile />
    <nav-bar-footer-mobile />
  </header>
</template>

<script lang="ts">
import NavBar from "~/components/navigation/NavBar.vue";
import SearchBar from "~/components/navigation/SearchBar.vue";
import NavBarMobile from "~/components/navigation/NavBarMobile.vue";
import NavBarFooterMobile from "~/components/navigation/NavBarFooterMobile.vue";
import SecondaryNavBar from "~/components/navigation/SecondaryNavBar.vue";
import ButtonNotifications from "~/components/buttons/ButtonNotifications.vue";
import { HomeService } from "~/services/HomeService";
import auth from "~/services/AuthService";
// import WishlistNav from "~/components/wishlist/WishlistNav.vue";

export default {
  components: {
    NavBar,
    SearchBar,
    NavBarMobile,
    SecondaryNavBar,
    NavBarFooterMobile,
    ButtonNotifications,
    // WishlistNav,
  },
  data() {
    return {
      isClientReady: false,
    };
  },
  computed: {
    isUserAuthenticated() {
      return auth.isUserLogged();
    },
  },
  mounted() {
    this.isClientReady = true;
    const homeService = new HomeService();
    homeService.getHeaderInitData();
  },
};
</script>

<style lang="scss">
.main-header {
  z-index: 1021; // asegura que se muestre por encima de los sticky-top cuando esta activo el menú
}
</style>
